import { render, staticRenderFns } from "./doctor-table.vue?vue&type=template&id=3d37414e&"
import script from "./doctor-table.vue?vue&type=script&lang=js&"
export * from "./doctor-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports